define(['../../../settings/settings-navigation'], function (getSettingsNavigation) {
    controller.$inject = ['$scope', '$rootScope', '$translate', '$state', 'SuiteNavigation', 'AuthService', 'UserService', '$location', 'ProjectsService', 'FavIconService', 'LanguageService', '$sce', 'SuiteTheme', 'PlanDetailsService'];

    function controller($scope, $rootScope, $translate, $state, SuiteNavigation, AuthService, UserService, $location, ProjectsService, FavIconService, LanguageService, $sce, SuiteTheme, PlanDetailsService) {
        $scope.allLanguages = $translate.getAvailableLanguageKeys();
        $scope.currentPromo = PlanDetailsService.isPromoTime()
            ? PlanDetailsService.getCurrentPromo()
            : null;

        $translate('currentLangCode')
            .then(function (translated) {
                $scope.selectedLang = translated;
            });

        $scope.switchLang = switchLang;
        $scope.languageName = LanguageService.getLanguageName;
        $scope.languageFlag = LanguageService.getLanguageFlag;
        $scope.isDarkTheme = SuiteTheme.isDark();
        $scope.toggleTheme = function () {
            SuiteTheme.toggle();
        };
        $scope.$on('suiteThemeChanged', function (event, mode) {
            $scope.isDarkTheme = mode === 'dark';
        });
        $scope.$state = $state;
        $scope.location = $location;
        $scope.settingsGroups = getSettingsNavigation();
        $scope.isSettings = function () { return $state.includes('app.settings'); };
        /* An entry can stay active across several states: the projects list and any project inside it. */
        $scope.isItemActive = function (item) {
            var states = angular.isArray(item.active) ? item.active : [item.active];
            return states.some(function (name) { return $state.includes(name); });
        };
        /* A single workspace is not worth a switcher in the menu. */
        $scope.workspaceCount = null;
        $scope.setWorkspaceCount = function (count) { $scope.workspaceCount = count; };
        $scope.newProjectRoute = "app.project.wizard({step:'create-project', from:'sidebar'})";
        $scope.closeNavigation = function () { SuiteNavigation.close(); };
        var PROJECT_LIMIT = 5;
        $scope.projectList = [];
        $scope.visibleProjects = [];
        $scope.projectsOpen = true;
        $scope.projectsOverflow = false;
        $scope.toggleProjects = function () { $scope.projectsOpen = !$scope.projectsOpen; };
        $scope.isProjectsActive = function () { return $state.includes('app.welcome') || $state.includes('app.project'); };
        $scope.isCurrentProject = function (id) {
            var current = $state.params && $state.params.projectId;
            return !!current && String(current) === String(id);
        };
        var projectsLoading = false;
        var projectsLoadedFor = null;
        loadProjects();
        /* The menu is built before the session is restored, so retry once the user is known. */
        $scope.$watch('$ctrl.currentUser', function (user) {
            if (user && user.account !== 'offline') loadProjects(user.email || user.id);
        });

        function loadProjects(userKey) {
            if (!AuthService.isAuthenticated()) {
                return;
            }
            if (projectsLoading || (userKey && projectsLoadedFor === userKey)) {
                return;
            }
            projectsLoading = true;
            projectsLoadedFor = userKey || projectsLoadedFor;
            ProjectsService.findAllPreview()
                .then(function (projects) {
                    $scope.projectList = (angular.isArray(projects) ? projects : []).map(function (project) {
                        var url = (project.crawlerProject && project.crawlerProject.url) ||
                            (project.trackerProject && project.trackerProject.linkUrl) || '';
                        project.faviconUrl = url ? FavIconService.get(url) : null;
                        return project;
                    });
                    /* Scalable list: the menu shows a few projects, the rest lives in the projects page. */
                    $scope.visibleProjects = $scope.projectList.slice(0, PROJECT_LIMIT);
                    $scope.projectsOverflow = $scope.projectList.length > $scope.visibleProjects.length;
                })
                .catch(function () {
                    $scope.projectList = [];
                    $scope.visibleProjects = [];
                    $scope.projectsOverflow = false;
                })
                .finally(function () { projectsLoading = false; });
        }

        $rootScope.$on('deleteProject', loadProjects);

        var toolIcons = {
            seo: toolIcon(
                '<path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />' +
                '<path d="M15.51 15.56a5 5 0 1 0 -3.51 1.44" />' +
                '<path d="M18.832 17.86a9 9 0 1 0 -6.832 3.14" />' +
                '<path d="M12 12v9" />'
            ),
            affiliate: toolIcon(
                '<path d="M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275" />' +
                '<path d="M11.683 12.317l5.759 -5.759" />' +
                '<path d="M4 5.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0" />' +
                '<path d="M17 5.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0" />' +
                '<path d="M17 18.5a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0" />' +
                '<path d="M4 15.5a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0" />'
            ),
            worldSearch: toolIcon(
                '<path d="M21 12a9 9 0 1 0 -9 9" />' +
                '<path d="M3.6 9h16.8" />' +
                '<path d="M3.6 15h7.9" />' +
                '<path d="M11.5 3a17 17 0 0 0 0 18" />' +
                '<path d="M12.5 3a16.984 16.984 0 0 1 2.574 8.62" />' +
                '<path d="M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />' +
                '<path d="M20.2 20.2l1.8 1.8" />'
            ),
            folders: toolIcon(
                '<path d="M9 3h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />' +
                '<path d="M17 16v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2" />'
            ),
            browserCheck: toolIcon(
                '<path d="M4 5a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1l0 -14" />' +
                '<path d="M4 8h16" />' +
                '<path d="M8 4v4" />' +
                '<path d="M9.5 14.5l1.5 1.5l3 -3" />'
            ),
            ai: toolIcon(
                '<path d="M14 3h-7a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h5" />' +
                '<path d="M14 3v5h5" />' +
                '<path d="M9 12h5" />' +
                '<path d="M9 16h3" />' +
                '<path d="M13.5 20.5l4 -4l2 2l-4 4l-2.5 .5l.5 -2.5" />' +
                '<path d="M19 3.5v3" />' +
                '<path d="M17.5 5h3" />'
            ),
            textScan: toolIcon(
                '<path d="M8 12h8" />' +
                '<path d="M8 9h6" />' +
                '<path d="M8 15h4" />' +
                '<path d="M3 7v-2a2 2 0 0 1 2 -2h2" />' +
                '<path d="M3 17v2a2 2 0 0 0 2 2h2" />' +
                '<path d="M17 3h2a2 2 0 0 1 2 2v2" />' +
                '<path d="M17 21h2a2 2 0 0 0 2 -2v-2" />'
            ),
            userSearch: toolIcon(
                '<path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />' +
                '<path d="M6 21v-2a4 4 0 0 1 4 -4h1.5" />' +
                '<path d="M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />' +
                '<path d="M20.2 20.2l1.8 1.8" />'
            ),
            signIn: toolIcon(
                '<path d="M10 17l4 -5l-4 -5" />' +
                '<path d="M15 12h-9" />' +
                '<path d="M14 5v-1a2 2 0 0 1 2 -2h3a2 2 0 0 1 2 2v16a2 2 0 0 1 -2 2h-3a2 2 0 0 1 -2 -2v-1" />'
            ),
            pricing: toolIcon(
                '<path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2" />' +
                '<path d="M9 8h6" />' +
                '<path d="M9 12h6" />'
            )
        };

        $scope.navigationGroups = [
            {name: 'SEO Tools', items: [
                {name: 'SEO/AEO Checker', translate: false, route: 'app.seochecker.landing', active: 'app.seochecker', icon: 'ti ti-radar-2', iconSvg: toolIcons.seo, permission: 'seo_checker_edit'},
                {name: 'Backlink Checker', route: 'app.backlinkchecker.tool', active: 'app.backlinkchecker', icon: 'ti ti-affiliate', iconSvg: toolIcons.affiliate},
                {name: 'Keyword Explorer', route: 'app.keywordexplorer.search', active: 'app.keywordexplorer.search', icon: 'ti ti-world-search', iconSvg: toolIcons.worldSearch, permission: 'keyword_explorer_edit'},
                {name: 'Keyword Manager', route: 'app.keywordlistmanager.v2', active: 'app.keywordlistmanager', icon: 'ti ti-folders', iconSvg: toolIcons.folders, permission: 'keyword_list_read'},
                {name: 'SERP Checker', route: 'app.serpchecker.tool.benchmark.backlink', active: 'app.serpchecker', icon: 'ti ti-browser-check', iconSvg: toolIcons.browserCheck, permission: 'serp_checker_edit'},
                {name: 'Writer Assistant AI', translate: false, route: 'app.writerassistant.landing', active: 'app.writerassistant', icon: 'ti ti-ai', iconSvg: toolIcons.ai, permission: 'editor_read'},
                {name: 'Copy Metrics', route: 'app.copymetrics.landing', active: 'app.copymetrics', icon: 'ti ti-text-scan-2', iconSvg: toolIcons.textScan, permission: 'copy_metrics_edit'},
                {name: 'Lead Generation', route: 'app.leadgeneration.landing', active: 'app.leadgeneration', icon: 'ti ti-user-search', iconSvg: toolIcons.userSearch, permission: 'lead_gen_read'}
            ]},
            {name: 'Account', translate: false, items: [
                {name: 'pricing', route: 'upgrade.choose-plan', active: 'upgrade.choose-plan', icon: 'ti ti-receipt', iconSvg: toolIcons.pricing, promo: true}
            ]}
        ];
        $scope.pricingNavItem = $scope.navigationGroups[1].items[0];

        function toolIcon(contents) {
            return $sce.trustAsHtml(
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
                'stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" ' +
                'aria-hidden="true">' + contents + '</svg>'
            );
        }

        function switchLang(language) {
            $scope.selectedLang = language;
            $rootScope.setLang(language);
            if (!AuthService.isAuthenticated()) {
                return;
            }

            UserService.updateProfile({locale: language})
                .catch(function (err) {
                    console.log(err);
                });
        }

        $scope.onSwipeLeft = function () {
            SuiteNavigation.close();
        };

        var ctrl = this;
        $scope.$watch('$ctrl.pitchground', function (pitchground) {
            ctrl.pitchground = pitchground;
        });
        $scope.$watch('$ctrl.currentUser', function (currentUser) {
            $scope.currentUser = currentUser;
        });
        $scope.$watch('$ctrl.compact', function (compact) {
            $scope.compact = compact;
        });
        $scope.$watch('$ctrl.showPromoPricing', function (showPromoPricing) {
            $scope.showPromoPricing = !!showPromoPricing;
        });

    }

    return {
        templateUrl: 'app/modules/template/components/st-sidebar-mini/st-sidebar-mini.html',
        controller: controller,
        bindings: {currentUser: '=', compact: '=', showPromoPricing: '<'}
    };
});
